var moduleName = "service.requestInterceptor";

/**
 * Listen to all http responses for 403 then act accordingly.
 */
function RequestInterceptorService($q) {
  var $this = this;
  $this.globalMessage = {
    class: "alert-danger",
    error: false,
    errorMsg: "Unknown error has occurred",
  };
  $this.timeout = null;

  return {
    getGlobalMessage: function () {
      return $this.globalMessage;
    },
    responseError: function (response) {
      if (response.status === 403) {
        if (response.data) {
          var result = response.data;
          //Get to std return object (this also ensures is the ajax listener causing the redirect and not endless page refreshes on an invalid request)
          if (result.data && result.data.redirect) {
            //ensure we don't endlessly redirect
            if (window.location.pathname !== result.data.redirect) {
              //Add some know exceptions where 403 should not be thrown, but where we also should NOT redirect if it is
              if (window.location.pathname !== "/app/login" &&
                window.location.pathname !== "/app/password" &&
                window.location.pathname !== "/app/register" &&
                window.location.pathname !== "/app/verify") {
                //This should force another http request, fixing server side session issues preferable to just state change
                window.location.href = result.data.redirect;
              }
            }
          }
        }
        return $q.reject(response);
      }
      else if (response.status === 500) {
        $this.globalMessage.error = true;
        $this.globalMessage.errorMsg = "The server is experiencing an unexpected error it currently cannot be contacted successfully, please try again later.";
        //Hide after setting
        if ($this.timeout) {
          clearTimeout($this.timeout);
        }
        $this.timeout = setTimeout(function () {
          $this.globalMessage.error = false;
        }, 10000);

        return $q.reject(response);
      }
      else {
        return $q.reject(response);
      }
    },
  };
}

/**
 * Add to angular and make available (Note this is added as factory not just a service)
 */
export default angular.module(moduleName, [])
  .factory("RequestInterceptorService", ["$q", RequestInterceptorService])
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/request.interceptor.service.js
 **/